import { MORTGAGE_PROMO_TYPES } from '../../../constants/promos';
import { EPromoType, IPromoInfoSchema } from '../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

export const getAuthorDescription = (promo: IPromoInfoSchema, hasContacts: boolean): string | null => {
  if (promo.promoType === EPromoType.CianMortgage) {
    return null;
  }

  if (!hasContacts) {
    return null;
  }

  const isMortgage = MORTGAGE_PROMO_TYPES.includes(promo.promoType);
  const promoLabel = isMortgage ? 'ипотечном' : 'акционном';
  const agentLabel = promo.isFromBuilder ? 'застройщика' : 'представителя застройщика';

  return `Узнайте у ${agentLabel} подробности об ${promoLabel} предложении`;
};
